/* eslint-disable no-use-before-define */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  useParams,
  useNavigate,
  Navigate,
  useLocation,
} from "react-router-dom";
import IntlCurrencyInput from "react-intl-currency-input";
import InputMask from "react-input-mask";
import {
  Autocomplete,
  Box,
  Button,
  Card,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormLabel,
  IconButton,
  Stack,
  TextField,
  Chip,
  Select,
  MenuItem,
  Radio,
  RadioGroup,
} from "@mui/material";
import firebase, { storage } from "../../config/firebase";
import { getDownloadURL, ref, uploadString } from "firebase/storage";
import ShipperDialog from "../../components/popup-shipper/insert-shipper";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import LoopIcon from "@mui/icons-material/Loop";
import TextArea from "antd/es/input/TextArea";
import { Spin } from "antd";
import { Link } from "react-router-dom";
import NewMiniDrawer from "../../components/navMenu/menu-nav";
import GalleryDialog from "../frete/components/GalleryDialog";
import AlertDialogFreight from "../frete/components/AlertDialogFreight";
import ModernAlertDialog from "../frete/components/ModernAlertDialog";
import ModernStepper from "./components/ProgressStepsBudget";
import "./budget.css";
import shipperService from "../../service/shipper.service";
import userService from "../../service/user.service";
import Utils from "../../util/utils";
import ProductTable from "../../components/Product-Table-Freight/ProductTable";
import AddIcon from "@mui/icons-material/Add";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import PersonIcon from "@mui/icons-material/Person";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import InventoryIcon from "@mui/icons-material/Inventory";
import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import paymentService from "../../service/payment.service";
// CHANGED: util file renamed from pdfOrcamento.js to generateBugetPdf.js
import { gerarPdfOrcamento } from "../../util/generateBugetPdf";
import emailServiceBudget from "../../service/sendEmailWithAttachments.service";

require("firebase/auth");


function Budget() {
  let navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();
  const user = useSelector((state) => state.user);
  const users = useSelector((state) => state.user);
  const shippers = useSelector((state) => state.shipper);

  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState("Em Aberto");
  const [code, setCode] = useState("01");
  const [numberSerial, setNumberSerial] = useState(Date.now());

  // Pagador
  const [payingCustomer, setPayingCustomer] = useState("");
  const [cnpjPayingCustomer, setCnpjPayingCustomer] = useState("");
  const [uidShipperPayment, setUidShipperPayment] = useState("");
  const [selectedContact, setSelectedContact] = useState("");
  const [shipperContacts, setShipperContacts] = useState([]);

  // Veículo
  const [occupation, setOccupation] = useState("");
  const [freeOfCharge, setFreeOfCharge] = useState("");
  const [tipoVeículo, setTipoVeículo] = useState({
    dados: [
      { name: "FIORINO", selected: false },
      { name: "3/4", selected: false },
      { name: "TOCO", selected: false },
      { name: "VUC", selected: false },
      { name: "TRUCK", selected: false },
      { name: "BI-TRUCK", selected: false },
      { name: "CARRETA S", selected: false },
      { name: "CARRETA LS", selected: false },
      { name: "RODOTREM", selected: false },
      { name: "VANDERLEIA", selected: false },
    ],
  });
  const [typeBodyworkList, setTypeBodyworkList] = useState({
    dados: [
      { name: "BAU", selected: false },
      { name: "BAU FRIGORIFICO", selected: false },
      { name: "BAU REFRIGERADO", selected: false },
      { name: "SIDER", selected: false },
      { name: "CACAMBA", selected: false },
      { name: "GRADE BAIXA", selected: false },
      { name: "GRANELEIRO", selected: false },
      { name: "PLATAFORMA", selected: false },
      { name: "PRANCHA", selected: false },
      { name: "APENAS CAVALO", selected: false },
      { name: "BUG PORTA CONTAINER", selected: false },
      { name: "CAVAQUEIRA", selected: false },
      { name: "CEGONHEIRO", selected: false },
      { name: "GAIOLA", selected: false },
      { name: "HOPPER", selected: false },
      { name: "MUNCK", selected: false },
      { name: "SILLO", selected: false },
      { name: "TANQUE", selected: false },
    ],
  });

  // Precificacao
  const [product, setProduct] = useState([]);

  // Resumo da Negociação
  const [seller, setSeller] = useState(users?.name || "");
  const [sellersList, setSellersList] = useState([]);
  const [weightCargo, setWeightCargo] = useState(0);
  const [valueNF, setValueNF] = useState("");
  const [valueFreightage, setValueFreightage] = useState("");
  const [paymentCondition, setPaymentCondition] = useState("");
  // Lista dinamica de condicoes de pagamento vindas do cadastro do embarcador (newEmbarcador).
  const [paymentConditionOptions, setPaymentConditionOptions] = useState([]);
  const [deliveryDeadline, setDeliveryDeadline] = useState("");
  const [observation, setObservation] = useState("");
  const [verifyPayment, setVerifyPayment] = useState(false);

  // Pontos de parada
  const generateNumberCollect = () => {
    const digitosUnicos = new Set();
    while (digitosUnicos.size < 7) {
      const digito = Math.floor(Math.random() * 10);
      digitosUnicos.add(digito);
    }
    return Array.from(digitosUnicos).join("");
  };
  const [formFields, setFormFields] = useState([
    {
      id: "",
      stop_order: 1,
      number_collect: generateNumberCollect(),
      name: "",
      cpf_cnpj: "",
      operation: [],
      responsible_phone: "",
      responsible_name: "",
      date_operation: "",
      time_operation: "",
      cep: "",
      number: "",
      logradouro: "",
      city: "",
      uf: "",
      latitude: "",
      longitude: "",
      observation: "",
    },
  ]);

  const [listShipper, setListShipper] = useState([]);
  const [listECShipper, setListECShipper] = useState("Embarcador");
  const [openShipper, setOpenShipper] = useState(false);
  const [carregando, setCarregando] = useState(0);
  const [msgTipo, setMsgTipo] = useState();
  const [msg, setMsg] = useState();
  const [title, setTitle] = useState();
  const [open, setOpen] = useState(false);
  const [canApprove, setCanApprove] = useState(false);
  const [view, setOnlyView] = useState(false);
  const [referenc, setReferenc] = useState("");
  const [origem, setOrigem] = useState("");
  const [openOrigem, setOpenOrigem] = useState(false);
  const [nameButtonImport, setNameButtonImport] = useState("Importar Canhoto");
  const [currentOperationType, setCurrentOperationType] = useState("");

  const db = firebase.firestore();

  // Google Maps API Key (buscar do ambiente ou fallback)
  const key =
    process.env.REACT_APP_GOOGLE_MAPS_API_KEY ||
    "AIzaSyAds1TwGzvflRvD8KHrbRHrnF3DvATFM1k";

  // Carregar lista de vendedores
  async function loadingSellers() {
    try {
      const list = await userService.usersAssociatedWithFortio();
      setSellersList(list);
    } catch (error) {
      console.error("Erro ao carregar vendedores:", error);
    }
  }

  useEffect(() => {
    loadingSellers();
  }, []);

  // Extrai e normaliza as condicoes de pagamento salvas no financeiro do embarcador.
  // Suporta tanto o formato novo (array) quanto o legado (campo unico).
  const resolvePaymentConditionsFromShipper = (shipperData) => {
    const financial = shipperData?.financial || {};

    const descriptions = Array.isArray(financial.paymentConditionDescriptions)
      ? financial.paymentConditionDescriptions
      : [];

    const legacyDescription = financial.paymentConditionDescription
      ? [financial.paymentConditionDescription]
      : [];

    const idFallback = Array.isArray(financial.paymentConditionIds)
      ? financial.paymentConditionIds
      : (financial.paymentConditionId ? [financial.paymentConditionId] : []);

    const merged = [...descriptions, ...legacyDescription];

    // Remove vazio/duplicado e, se nao houver descricao, usa ID como fallback visual.
    const normalized = Array.from(
      new Set(
        merged
          .map((item) => String(item || "").trim())
          .filter(Boolean)
      )
    );

    if (normalized.length > 0) return normalized;

    return Array.from(
      new Set(
        idFallback
          .map((item) => String(item || "").trim())
          .filter(Boolean)
      )
    );
  };

  // Carregar shippers
  async function loadingShipper() {
    try {
      if (users?.viewALL) {
        const result = await db.collection("shipper").get();
        const shippers = [];
        result.docs.forEach((doc) => {
          shippers.push({
            id: doc.id,
            ...doc.data(),
          });
        });
        setListShipper(shippers);
        setCarregando(0);
      } else {
        if (users?.uidShipperAffiliates && Array.isArray(users.uidShipperAffiliates)) {
          const affiliateUids = Array.isArray(users?.uidShipperAffiliates) ? users.uidShipperAffiliates : [];
          const primaryUid = users?.uidShipper ? [users.uidShipper] : [];
          const uids = Array.from(new Set([...affiliateUids, ...primaryUid]));

          const shippers = [];
          for (const uid of uids) {
            try {
              const docRef = db.collection("shipper").doc(uid);
              const docSnap = await docRef.get();
              if (docSnap.exists) {
                shippers.push({
                  id: docSnap.id,
                  ...docSnap.data(),
                });
              }
            } catch (err) {
              console.error(`Erro ao buscar shipper ${uid}:`, err);
            }
          }
          setListShipper(shippers);
          setCarregando(0);
        } else {
          const result = await db
            .collection("shipper")
            .doc(users.uidShipper)
            .get();
          if (result.exists) {
            setListShipper([
              {
                id: result.id,
                ...result.data(),
              },
            ]);
          }
          setCarregando(0);
        }
      }
    } catch (error) {
      setCarregando(0);
      console.error("Erro ao buscar shippers:", error);
    }
  }

  // Carregar contatos do shipper selecionado diretamente da tabela shipper
  const normalizeTransportOptionName = (value) =>
    String(value || "")
      .toUpperCase()
      .replace(/Ã|Ãš|Ú/g, "U")
      .replace(/Ã|Ã‡|Ç/g, "C")
      .replace(/Ã|Ã€|Ã‚|Ãƒ|Á|À|Â|Ã/g, "A")
      .replace(/Ã‰|ÃŠ|É|Ê/g, "E")
      .replace(/Ã|Í/g, "I")
      .replace(/Ã“|Ã”|Ã•|Ó|Ô|Õ/g, "O")
      .replace(/Ãš|Ú/g, "U")
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/\s+/g, " ")
      .trim();

  const mergeSelectionOptions = (defaultState, incomingState) => {
    const defaultItems = Array.isArray(defaultState?.dados) ? defaultState.dados : [];
    const incomingItems = Array.isArray(incomingState?.dados) ? incomingState.dados : [];

    if (!incomingItems.length) return defaultState;

    const incomingByName = new Map(
      incomingItems.map((item) => [
        normalizeTransportOptionName(item?.name),
        Boolean(item?.selected),
      ])
    );

    return {
      ...defaultState,
      dados: defaultItems.map((item) => {
        const key = normalizeTransportOptionName(item.name);
        return {
          ...item,
          selected: incomingByName.has(key)
            ? incomingByName.get(key)
            : Boolean(item.selected),
        };
      }),
    };
  };
  useEffect(() => {
    const loadContacts = async () => {
      if (uidShipperPayment) {
        try {
          const shipperDoc = await db.collection("shipper").doc(uidShipperPayment).get();
          if (shipperDoc.exists) {
            const shipperData = shipperDoc.data();
            let contacts = [];

            // Normalizar contatos para formato consistente
            if (Array.isArray(shipperData.contact)) {
              // Se for array, normalizar cada contato
              contacts = shipperData.contact.map((contact) => {
                if (typeof contact === "object" && contact !== null) {
                  return {
                    nome: contact.nome || contact.name || "",
                    telefone: contact.telefone || contact.phoneNumberFirst || contact.phone || "",
                    email: contact.email || "",
                  };
                }
                return { nome: "", telefone: String(contact || ""), email: "" };
              });
            } else if (shipperData.contact && typeof shipperData.contact === "object") {
              // Se for objeto unico, converter para array normalizado
              contacts = [{
                nome: shipperData.contact.nome || shipperData.contact.name || "",
                telefone: shipperData.contact.telefone || shipperData.contact.phoneNumberFirst || shipperData.contact.phone || "",
                email: shipperData.contact.email || "",
              }];
            }

            setShipperContacts(contacts);
            // Atualiza as opcoes de pagamento com base no financeiro do embarcador selecionado.
            setPaymentConditionOptions(resolvePaymentConditionsFromShipper(shipperData));
          } else {
            setShipperContacts([]);
            setPaymentConditionOptions([]);
          }
        } catch (error) {
          console.error("Erro ao carregar contatos da tabela shipper:", error);
          setShipperContacts([]);
          setPaymentConditionOptions([]);
        }
      } else {
        setShipperContacts([]);
        setSelectedContact("");
        setPaymentConditionOptions([]);
      }
    };
    loadContacts();
  }, [uidShipperPayment]);

  useEffect(() => {
    loadingShipper();
  }, [users]);

  // Carregar dados do orcamento se estiver editando
  useEffect(() => {
    if (id) {
      loadBudgetData();
    }
  }, [id]);

  async function loadBudgetData() {
    setCarregando(1);
    try {
      const budgetDoc = await db.collection("tb_budget").doc(id).get();
      if (budgetDoc.exists) {
        const data = budgetDoc.data();
        setPayingCustomer(data.clientPayment?.name || "");
        setCnpjPayingCustomer(data.clientPayment?.cnpj || "");
        setUidShipperPayment(data.clientPayment?.uid || "");

        // Carregar o shipper completo para persistir no campo
        if (data.clientPayment?.uid) {
          try {
            const shipperDoc = await db.collection("shipper").doc(data.clientPayment.uid).get();
            if (shipperDoc.exists) {
              const shipperData = {
                id: shipperDoc.id,
                ...shipperDoc.data(),
              };
              setListECShipper(shipperData);
              // Carrega as condicoes do financeiro do embarcador ao abrir orcamento existente.
              setPaymentConditionOptions(resolvePaymentConditionsFromShipper(shipperData));
            }
          } catch (error) {
            console.error("Erro ao carregar shipper:", error);
          }
        }

        // Carregar contato - pode ser objeto ou string
        const contactData = data.contact || "";
        if (contactData && typeof contactData === "object") {
          setSelectedContact(contactData);
        } else {
          setSelectedContact(contactData);
        }
        setOccupation(data.vehicle?.occupation || "");
        setFreeOfCharge(data.vehicle?.freeOfCharge || "");
        setTipoVeículo((prev) => mergeSelectionOptions(prev, data.vehicle?.typeVehicle));
        setTypeBodyworkList((prev) => mergeSelectionOptions(prev, data.vehicle?.typeBodywork));
        setProduct(data.pricing?.products || []);
        setSeller(data.summary?.seller || "");
        setWeightCargo(data.summary?.weightCargo || 0);
        setValueNF(data.summary?.valueNF || "");
        setValueFreightage(data.summary?.valueFreightage || "");
        setPaymentCondition(data.summary?.paymentCondition || "");
        setDeliveryDeadline(data.summary?.deliveryDeadline || "");
        setObservation(data.summary?.observation || "");
        setStatus(data.status?.describe || "Em Aberto");
        setCode(data.status?.code || "01");
        setNumberSerial(data.numberSerial || Date.now());

        // Carregar pontos de parada
        const stopsSnapshot = await db
          .collection("tb_budget")
          .doc(id)
          .collection("stopping_points")
          .orderBy("stop_order", "asc")
          .get();
        const stops = [];
        stopsSnapshot.docs.forEach((doc) => {
          stops.push({ id: doc.id, ...doc.data() });
        });
        // Ordenar por stop_order para garantir a ordem correta
        stops.sort((a, b) => (a.stop_order || 0) - (b.stop_order || 0));
        const normalizedStops = stops.length > 0
          ? stops.map((stop) => ({
            ...stop,
            number_collect: stop.number_collect || generateNumberCollect(),
          }))
          : formFields;
        setFormFields(normalizedStops);

        // Verificar se pode aprovar (se status nao for Aprovado ou Cancelado)
        if (data.status?.describe !== "Aprovado" && data.status?.describe !== "Cancelado") {
          setCanApprove(true);
        }
      }
      setCarregando(0);
    } catch (error) {
      console.error("Erro ao carregar orçamento:", error);
      setCarregando(0);
    }
  }

  // Handler para mudanca de shipper - garante que todos os dados venham da tabela shipper
  const handleChangeShipper = (shipperData) => {
    if (shipperData) {
      // Garantir que os dados vem diretamente da tabela shipper
      const shipperId = shipperData.id || "";
      const socialName = shipperData?.dataPersonal?.socialName || "";
      const nameFantasy = shipperData?.dataPersonal?.nameFantasy || "";
      const documentNumber = shipperData?.dataPersonal?.documentNumber || "";

      // Atualizar estados com dados da tabela shipper
      setPayingCustomer(socialName || nameFantasy);
      setCnpjPayingCustomer(documentNumber);
      setUidShipperPayment(shipperId);
      setListECShipper(shipperData);
      // Sincroniza as opcoes de pagamento com o financeiro do embarcador escolhido.
      setPaymentConditionOptions(resolvePaymentConditionsFromShipper(shipperData));

      // Limpar contato selecionado quando mudar o shipper
      setSelectedContact("");
      // Limpa a condicao escolhida para evitar manter opcao invalida do embarcador anterior.
      setPaymentCondition("");
    } else {
      // Se nao houver shipper selecionado, limpar todos os campos
      setPayingCustomer("");
      setCnpjPayingCustomer("");
      setUidShipperPayment("");
      setListECShipper(null);
      setSelectedContact("");
      setShipperContacts([]);
      setPaymentConditionOptions([]);
      setPaymentCondition("");
    }
  };

  // Handler para produtos (precificacao)
  const handleProductsChange = (newProducts) => {
    setProduct(newProducts);
    const total = newProducts?.reduce(
      (sum, prod) => sum + (prod.total || 0),
      0
    ) || 0;
    setValueFreightage(total);
  };

  // Adicionar ponto de parada
  const addFields = () => {
    const object = {
      id: "",
      stop_order: formFields.length + 1,
      number_collect: generateNumberCollect(),
      name: "",
      cpf_cnpj: "",
      operation: [],
      responsible_phone: "",
      responsible_name: "",
      date_operation: "",
      time_operation: "",
      cep: "",
      number: "",
      logradouro: "",
      city: "",
      uf: "",
      latitude: "",
      longitude: "",
      observation: "",
    };
    setFormFields([...formFields, object]);
  };

  // Remover ponto de parada
  const deleteItem = (form, index) => {
    const newFormFields = formFields.filter((_, i) => i !== index);
    // Reordenar
    newFormFields.forEach((field, i) => {
      field.stop_order = i + 1;
    });
    setFormFields(newFormFields);
  };

  // Handler para mudanca nos campos do formulario
  const handleFormChange = (event, index) => {
    const { name, value, type, checked } = event.target;
    const newFormFields = [...formFields];
    if (type === "checkbox") {
      newFormFields[index][name] = checked;
    } else {
      newFormFields[index][name] = value;
    }
    setFormFields(newFormFields);
  };

  // Handler para checkbox de carga/descarga
  const handleCheckBoxChange = (event, index) => {
    const { name, checked } = event.target;
    if (name === "carga" || name === "descarga") {
      setFormFields((prev) => {
        const data = [...prev];
        if (!Array.isArray(data[index].operation)) {
          data[index].operation = [];
        }
        if (checked) {
          data[index].operation = [name];
        } else {
          data[index].operation = [];
        }
        return data;
      });
    }
  };

  //----------------------------- checked box ------------------------------------

  const handleOnChange = (e, type) => {
    const { name, checked } = e.target;
    const newTypeVehicle = [...tipoVeículo[type]];
    const index = newTypeVehicle.findIndex((h) => h.name === name);
    if (index > -1) {
      newTypeVehicle[index] = { name, selected: checked };
    }
    setTipoVeículo((h) => ({ ...h, [type]: newTypeVehicle }));
  };

  const renderCheckboxList = (options, type) =>
    options.map((opt) => (
      <div key={opt.name} className="checkbox-container">
        <input
          disabled={view}
          type="checkbox"
          name={opt.name}
          onChange={(e) => handleOnChange(e, type)}
          checked={opt.selected}
        />
        {opt.name}
      </div>
    ));

  const categories = {
    Leve: ["FIORINO", "3/4", "TOCO", "VUC"],
    Medio: ["TRUCK", "BI-TRUCK"],
    Pesado: ["CARRETA S", "CARRETA LS", "RODOTREM", "VANDERLEIA"],
  };

  const renderCategories = () => {
    return Object.keys(categories).map((category) => {
      const filteredOptions = tipoVeículo.dados.filter((vehicle) =>
        categories[category].includes(vehicle.name)
      );

      return (
        <div key={category}>
          <div className="category-column">
            <h6 className="category-title">{category}</h6>

            {renderCheckboxList(filteredOptions, "dados")}
          </div>
        </div>
      );
    });
  };

  const handleOnChangeBodyWork = (e, type) => {
    const { name, checked } = e.target;
    const newTypeBodyWork = [...typeBodyworkList[type]];
    const index = newTypeBodyWork.findIndex((h) => h.name === name);
    if (index > -1) {
      newTypeBodyWork[index] = { name, selected: checked };
    }
    setTypeBodyworkList((h) => ({ ...h, [type]: newTypeBodyWork }));
  };

  const renderCheckboxListBodyWork = (options, type) =>
    options.map((opt) => (
      <div key={opt.name} className="checkbox-container">
        <input
          disabled={view}
          type="checkbox"
          name={opt.name}
          onChange={(e) => handleOnChangeBodyWork(e, type)}
          checked={opt.selected}
        />
        {opt.name}
      </div>
    ));

  const categoriesBodyWork = {
    Fechada: ["BAU", "BAU FRIGORIFICO", "BAU REFRIGERADO", "SIDER"],
    Aberta: ["CACAMBA", "GRADE BAIXA", "GRANELEIRO", "PLATAFORMA", "PRANCHA"],
    Especial: [
      "BUG PORTA CONTAINER",
      "CAVAQUEIRA",
      "CEGONHEIRO",
      "GAIOLA",
      "HOPPER",
      "MUNCK",
      "SILLO",
      "TANQUE",
    ],
  };

  const renderCategoriesBodyWork = () => {
    return Object.keys(categoriesBodyWork).map((category) => {
      const filteredOptions = typeBodyworkList.dados.filter((vehicle) =>
        categoriesBodyWork[category].includes(vehicle.name)
      );
      return (
        <div key={category}>
          <div className="category-column">
            <h6 style={{ fontWeight: "bold", fontSize: "14px" }}>{category}</h6>
            {renderCheckboxListBodyWork(filteredOptions, "dados")}
          </div>
        </div>
      );
    });
  };

  // Funcoes auxiliares
  function handleNameButtonImport(index) {
    if (index === "carga") {
      setNameButtonImport("Importar Canhoto");
      return;
    } else {
      setNameButtonImport("Importar imagens");
    }
  }

  const duplicateForm = (index) => {
    setFormFields((prev) => {
      const formToDuplicate = prev[index];
      if (!formToDuplicate) {
        console.error("Formulário não encontrado no índice:", index);
        return prev;
      }
      let newForm = JSON.parse(JSON.stringify(formToDuplicate));
      newForm.stop_order = formToDuplicate.stop_order + 1;
      newForm.date_operation = "";
      newForm.time_operation = "";
      newForm.observation = "";
      newForm.number_collect = Date.now();
      return [...prev, newForm];
    });
  };

  const geocodeStopPoint = (index, logradouro, number, city, uf) => {
    if (!logradouro || !city || !uf) return;

    const enderecoCompleto = number
      ? `${logradouro} ${number} ${city} ${uf}`
      : `${logradouro} ${city} ${uf}`;

    fetch(
      `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(enderecoCompleto)}&key=${key}`
    )
      .then((res) => res.json())
      .then((data2) => {
        if (data2.status === "OK") {
          const coords = data2.results[0].geometry.location;
          setFormFields((prev) => {
            const next = [...prev];
            next[index] = {
              ...next[index],
              latitude: coords.lat,
              longitude: coords.lng,
              checkItemLocation: true,
            };
            return next;
          });
        }
      })
      .catch((err) => console.error("Erro ao buscar coordenadas:", err));
  };

  function buscarCNPJBancoClient(input, index) {
    if (input.length < 14) {
      return;
    } else if (input.length === 14 || input.length === 18) {
      const inputLimpo = input.replace(/[^\d]/g, "");

      // Primeiro verificar se o CNPJ corresponde ao CNPJ do pagador
      const cnpjPayingCustomerLimpo = cnpjPayingCustomer?.replace(/[^\d]/g, "") || "";

      if (inputLimpo === cnpjPayingCustomerLimpo && uidShipperPayment) {
        // Se corresponder ao pagador, buscar dados do shipper
        db.collection("shipper")
          .doc(uidShipperPayment)
          .get()
          .then((shipperDoc) => {
            if (shipperDoc.exists) {
              const shipperData = shipperDoc.data();
              const address = shipperData.address || {};
              const logradouro = `${address.street || ""}${address.neighborhood ? " - " + address.neighborhood : ""}`.trim();
              const number = address.numeroEndereco || address.number || "";
              const city = address.city || "";
              const uf = address.state || "";

              // Preencher campos com dados do shipper
              setFormFields((prev) => {
                const newForm = [...prev];
                newForm[index] = {
                  ...newForm[index],
                  name: shipperData.dataPersonal?.socialName || shipperData.dataPersonal?.nameFantasy || payingCustomer || "",
                  cpf_cnpj: shipperData.dataPersonal?.documentNumber || cnpjPayingCustomer || "",
                  cep: address.cep || "",
                  number: number,
                  logradouro: logradouro,
                  city: city,
                  uf: uf,
                  // Preencher responsavel se houver contato
                  responsible_name: shipperData.contact && typeof shipperData.contact === "object" && !Array.isArray(shipperData.contact)
                    ? (shipperData.contact.name || shipperData.contact.nome || "")
                    : (Array.isArray(shipperData.contact) && shipperData.contact.length > 0
                      ? (shipperData.contact[0].name || shipperData.contact[0].nome || "")
                      : ""),
                  responsible_phone: shipperData.contact && typeof shipperData.contact === "object" && !Array.isArray(shipperData.contact)
                    ? (shipperData.contact.phoneNumberFirst || shipperData.contact.telefone || "")
                    : (Array.isArray(shipperData.contact) && shipperData.contact.length > 0
                      ? (shipperData.contact[0].phoneNumberFirst || shipperData.contact[0].telefone || "")
                      : ""),
                };
                return newForm;
              });

              geocodeStopPoint(index, logradouro, number, city, uf);
            }
          })
          .catch((err) => {
            console.error("Erro ao buscar dados do shipper:", err);
            // Se der erro, continuar com busca normal na tabela client
            buscarNaTabelaClient(inputLimpo, index);
          });
      } else {
        // Se nao corresponder ao pagador, buscar na tabela client normalmente
        buscarNaTabelaClient(inputLimpo, index);
      }
    }
  }

  // Funcao auxiliar para buscar na tabela client
  function buscarNaTabelaClient(inputLimpo, index) {
    db.collection("client")
      .where("cnpj", "==", inputLimpo)
      .get()
      .then((result) => {
        if (!result.empty) {
          const data = result.docs[0].data();
          const logradouro = `${data.address?.street || ""} - ${data.address?.neighborhood || ""}`;
          const number = data.address?.number || "";
          const city = data.address?.city || "";
          const uf = data.address?.state || "";
          setFormFields((prev) => {
            const newForm = [...prev];
            newForm[index] = {
              ...newForm[index],
              name: data.name,
              cpf_cnpj: data.cnpj,
              cep: data.address?.cep || "",
              number: number,
              logradouro: logradouro,
              city: city,
              uf: uf,
              latitude: data.coordinates?.latitude || "",
              longitude: data.coordinates?.longitude || "",
            };
            return newForm;
          });

          if (!data.coordinates?.latitude || !data.coordinates?.longitude) {
            geocodeStopPoint(index, logradouro, number, city, uf);
          }
        }
      })
      .catch((err) => console.error(err));
  }

  function buscarCepPaying(input, index) {
    if (input.length < 8) return;
    const inputLimpo = input.replace(/[^\d]/g, "");

    fetch("https://brasilapi.com.br/api/cep/v1/" + inputLimpo)
      .then((res) => res.json())
      .then((data) => {
        if (data.hasOwnProperty("erro") || data.name === "CepPromiseError") {
          alert("CEP não encontrado");
        } else {
          const logradouroCompleto = (data.street || "") + " - " + (data.neighborhood || "");

          setFormFields((prev) => {
            const aux = [...prev];
            aux[index] = {
              ...aux[index],
              logradouro: logradouroCompleto,
              city: data.city || "",
              uf: data.state || "",
            };
            return aux;
          });

          const numeroAtual = String(formFields?.[index]?.number || "").trim();
          geocodeStopPoint(
            index,
            logradouroCompleto,
            numeroAtual,
            data.city || "",
            data.state || ""
          );
        }
      })
      .catch((err) => console.error("Erro ao buscar CEP:", err));
  }

  function consultStreetByStreet(index) {
    const item = formFields[index];
    if (!item.logradouro || !item.city || !item.uf) {
      // Se nao tiver endereco completo, nao busca coordenadas
      return;
    }

    // Monta o endereco completo, incluindo numero se disponivel
    const enderecoCompleto = item.number
      ? `${item.logradouro} ${item.number} ${item.city} ${item.uf}`
      : `${item.logradouro} ${item.city} ${item.uf}`;

    fetch(`https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(enderecoCompleto)}&key=${key}`)
      .then((res) => res.json())
      .then((data2) => {
        if (data2.status === "OK") {
          const coords = data2.results[0].geometry.location;
          setFormFields((prev) => {
            const newForm = [...prev];
            newForm[index] = {
              ...newForm[index],
              latitude: coords.lat,
              longitude: coords.lng,
              checkItemLocation: true,
            };
            return newForm;
          });
        }
      })
      .catch((err) => console.error("Erro ao buscar coordenadas:", err));
  }

  const handleClickOpen = (id, operationType) => {
    setOpenOrigem(true);
    setReferenc(id);
    setCurrentOperationType(operationType || "");
  };

  const handleCloseModal = () => {
    setOpenOrigem(false);
  };

  const handleUpload = (file) => {
    if (!file) return;
    // Implementar logica de upload se necessario
    console.log("Upload file:", file);
  };

  const handleShipperCloseModal = () => {
    setOpenShipper(false);
  };

  const getDadaClient = (cnpj, razaosocial) => {
    setPayingCustomer(razaosocial);
    setCnpjPayingCustomer(cnpj);
  };

  const collectMissingFields = () => {
    const missing = [];

    if (!cnpjPayingCustomer) missing.push("CNPJ do Pagador");
    if (!payingCustomer) missing.push("Pagador");
    if (!selectedContact || selectedContact === "") missing.push("Contato");
    if (!occupation) missing.push("Ocupacao");
    if (!freeOfCharge) missing.push("Livre de Carga e Descarga");
    if (!seller) missing.push("Vendedor");
    if (!valueNF) missing.push("Valor NF");
    if (!weightCargo) missing.push("Peso Transportado");
    if (!valueFreightage) missing.push("Valor do Frete");
    if (!paymentCondition) missing.push("Condições de Pagamento");

    if (!formFields || formFields.length === 0) {
      missing.push("Pelo menos um ponto de parada");
      return missing;
    }

    formFields.forEach((stop, idx) => {
      const order = stop.stop_order || idx + 1;
      const prefix = `Ponto ${order}:`;

      if (!stop.name) missing.push(`${prefix} Nome/Razão Social`);
      if (!stop.cpf_cnpj) missing.push(`${prefix} CNPJ/CPF`);
      if (!stop.cep) missing.push(`${prefix} CEP`);
      if (!stop.logradouro) missing.push(`${prefix} Endereço`);
      if (!stop.number) missing.push(`${prefix} Numero`);
      if (!stop.city) missing.push(`${prefix} Cidade`);
      if (!stop.uf) missing.push(`${prefix} UF`);
      if (!stop.operation || stop.operation.length === 0) {
        missing.push(`${prefix} Selecione Carga ou Descarga`);
      }

      if (stop.operation?.includes("carga")) {
        if (!stop.type) missing.push(`${prefix} Tipo da Carga`);
        if (!stop.descricao) missing.push(`${prefix} Descrição da Carga`);
      }
    });

    const hasProductValue = (value) =>
      value !== null &&
      value !== undefined &&
      !(typeof value === "string" && value.trim() === "");

    for (const prod of product || []) {
      const hasName = hasProductValue(prod?.nameProducts);
      const hasAmount = hasProductValue(prod?.amount);
      const hasPriceList = hasProductValue(prod?.priceList);
      const hasAnyProductField = hasName || hasAmount || hasPriceList;

      if (hasAnyProductField && (!hasName || !hasAmount || !hasPriceList)) {
        missing.push("Precificacao: preencha nome, quantidade e valor unitario para cada item informado");
        break;
      }
    }

    return missing;
  };

  // Validacao
  function validInput() {
    const missing = collectMissingFields();
    if (missing.length > 0) {
      showMessage(["Alguns campos sao de preenchimento obrigatorio:", ...missing]);
      return false;
    }
    return true;
  }

  function showMessage(msg) {
    setMsgTipo("erro");
    setCarregando(0);
    setTitle("Campos obrigatorios!");
    setMsg(msg);
    setOpen(true);
    return;
  }

  // Salvar orcamento
  async function save(options = {}) {
    const { redirect = true } = options;
    setMsgTipo("erro");
    setCarregando(1);

    if (!validInput()) return null;

    const chosenStatus = {
      describe: status,
      code: code,
    };

    let customerPayment = {
      name: payingCustomer,
      cnpj: cnpjPayingCustomer,
      uid: uidShipperPayment,
    };

    let vehicle = {
      typeVehicle: tipoVeículo,
      typeBodywork: typeBodyworkList,
      occupation: occupation,
      freeOfCharge: freeOfCharge,
    };

    let pricing = {
      products: product,
    };

    let summary = {
      seller: seller,
      weightCargo: weightCargo,
      valueNF: valueNF,
      valueFreightage: valueFreightage,
      paymentCondition: paymentCondition,
      deliveryDeadline: deliveryDeadline,
      observation: observation,
      // Persistimos a quantidade de paradas extras para manter o mesmo valor ao reemitir PDF.
      additionalStops: Math.max((formFields?.length || 0) - 2, 0),
    };

    // Primeira e ultima rota
    var primeiraRota = formFields
      .filter((item) => item.stop_order)
      .slice(0, 1)[0];

    var ultimaRota = formFields.filter((item) => item.stop_order).slice(-1)[0];

    var firstDelivery = {
      name: primeiraRota.name,
      cep: primeiraRota.cep,
      address: primeiraRota.logradouro,
      city: primeiraRota.city,
      uf: primeiraRota.uf.length > 2
        ? Utils.searchingState(primeiraRota.uf)
        : primeiraRota.uf,
      dateColeta: primeiraRota.date_operation,
      coordinates: {
        latitude: primeiraRota.latitude,
        longitude: primeiraRota.longitude,
      },
    };

    var lastDelivery = {
      name: ultimaRota?.name,
      cep: ultimaRota?.cep,
      address: ultimaRota?.logradouro,
      city: ultimaRota?.city,
      uf: ultimaRota?.uf.length > 2
        ? Utils.searchingState(ultimaRota.uf)
        : ultimaRota.uf,
      dateColeta: ultimaRota.date_operation,
      coordinates: {
        latitude: ultimaRota?.latitude,
        longitude: ultimaRota?.longitude,
      },
    };

    let shipper = {
      uid: users.uidShipper,
      name: shippers?.dataPersonal?.socialName || "",
    };

    let userData = {
      uid: users.uid,
      name: users.name,
    };

    var data = {
      clientPayment: customerPayment,
      contact: selectedContact,
      firstDelivery: firstDelivery,
      lastDelivery: lastDelivery,
      status: chosenStatus,
      numberSerial: numberSerial,
      vehicle: vehicle,
      pricing: pricing,
      summary: summary,
      user: userData,
      shipper: shipper,
      createUser: users.email || "",
      createData: new Date(),
    };

    try {
      if (id) {
        // Atualizar
        await db.collection("tb_budget").doc(id).update(data);

        // Atualizar pontos de parada
        const existingStops = await db
          .collection("tb_budget")
          .doc(id)
          .collection("stopping_points")
          .get();

        // Deletar todos os pontos existentes
        const batch = db.batch();
        existingStops.docs.forEach((doc) => {
          batch.delete(doc.ref);
        });
        await batch.commit();

        // Adicionar novos pontos
        formFields.forEach(async (doc) => {
          const pointDataToSave = { ...doc };
          delete pointDataToSave.id;
          await db
            .collection("tb_budget")
            .doc(id)
            .collection("stopping_points")
            .add(pointDataToSave);
        });

        setCarregando(0);
        setMsgTipo("sucesso");
        setCanApprove(true);
        if (redirect) {
          navigate("/orcamento/listagem");
        }
        return id;
      } else {
        // Criar novo
        const docRef = await db.collection("tb_budget").add(data);

        // Salvar pontos de parada
        formFields.forEach(async (doc) => {
          const pointDataToSave = { ...doc };
          delete pointDataToSave.id;
          await db
            .collection("tb_budget")
            .doc(docRef.id)
            .collection("stopping_points")
            .add(pointDataToSave);
        });

        setCarregando(0);
        setMsgTipo("sucesso");
        setCanApprove(true);
        if (redirect) {
          navigate("/orcamento/listagem");
        }
        return docRef.id;
      }
    } catch (error) {
      console.error("Erro ao salvar orçamento:", error);
      setMsgTipo("erro");
      setCarregando(0);
      showMessage("Erro ao salvar orçamento");
    }
  }

  // Aprovar orcamento
  async function approveBudget() {
    if (!id) {
      showMessage("Orçamento não encontrado");
      return false;
    }

    try {
      setCarregando(1);

      // Buscar dados atualizados do orcamento
      const budgetDoc = await db.collection("tb_budget").doc(id).get();
      if (!budgetDoc.exists) {
        showMessage("Orçamento não encontrado");
        setCarregando(0);
        return false;
      }

      const budgetData = budgetDoc.data();

      // Buscar pontos de parada
      const stopsSnapshot = await db
        .collection("tb_budget")
        .doc(id)
        .collection("stopping_points")
        .get();

      const stops = [];
      stopsSnapshot.docs.forEach((doc) => {
        stops.push({ id: doc.id, ...doc.data() });
      });

      // Preparar dados para transferir para o frete
      const freightData = {
        fromBudget: true,
        budgetId: id,
        budgetData: budgetData,
        stops: stops,
        // Dados do pagador
        clientPayment: budgetData.clientPayment,
        // Dados do veiculo
        vehicle: budgetData.vehicle,
        // Dados da precificacao
        pricing: budgetData.pricing,
        // Dados do resumo
        summary: budgetData.summary,
        // Numero serial
        numberSerial: budgetData.numberSerial,
      };

      // Navegar para a tela de frete com os dados do orcamento
      navigate("/freight", {
        state: freightData,
      });

      setCarregando(0);
      return true;
    } catch (error) {
      console.error("Erro ao aprovar orçamento:", error);
      setCarregando(0);
      showMessage("Erro ao aprovar orçamento");
      return false;
    }
  }

  async function cancelBudget() {
    if (!id) {
      showMessage("Orçamento não encontrado");
      return false;
    }

    try {
      setCarregando(1);

      await db.collection("tb_budget").doc(id).update({
        status: {
          describe: "Cancelado",
          code: "04",
        },
      });

      setStatus("Cancelado");
      setCode("04");
      setCanApprove(false);
      setCarregando(0);
      return true;
    } catch (error) {
      console.error("Erro ao cancelar orçamento:", error);
      setCarregando(0);
      showMessage("Erro ao cancelar orçamento");
      return false;
    }
  }

  const handleStatusStepperConfirm = async (nextStatus) => {
    if (nextStatus === "Aprovado") {
      return await approveBudget();
    }
    if (nextStatus === "Cancelado") {
      return await cancelBudget();
    }
    return false;
  };

  const formatCurrencyBRL = (value) => {
    // Formata valores numericos no padrao monetario brasileiro para uso no PDF.
    const numericValue = Number(value || 0);
    return numericValue.toLocaleString("pt-BR", {
      style: "currency",
      currency: "BRL",
    });
  };

  const getSelectedNames = (list) =>
    // Retorna apenas os nomes dos itens marcados nas listas de veiculo/carroceria.
    (list?.dados || [])
      .filter((item) => item.selected)
      .map((item) => item.name);

  const extractContactData = (contactValue) => {
    // Normaliza o contato selecionado para um objeto unico com nome, telefone e email.
    if (!contactValue) return { nome: "-", telefone: "-", email: "-" };

    if (typeof contactValue === "object") {
      return {
        nome: contactValue.nome || contactValue.name || "-",
        telefone: contactValue.telefone || contactValue.phoneNumberFirst || contactValue.phone || "-",
        email: contactValue.email || "-",
      };
    }

    if (typeof contactValue === "string") {
      try {
        const parsed = JSON.parse(contactValue);
        return {
          nome: parsed.nome || parsed.name || "-",
          telefone: parsed.telefone || parsed.phoneNumberFirst || parsed.phone || "-",
          email: parsed.email || "-",
        };
      } catch {
        const parts = contactValue.split(" - ").map((part) => part.trim());
        return {
          nome: parts[0] || "-",
          telefone: parts[1] || "-",
          email: parts[2] || "-",
        };
      }
    }

    return { nome: "-", telefone: "-", email: "-" };
  };

  const normalizeContactObject = (contactValue) => {
    // Normaliza contato em formato estavel para evitar divergencia no value do Select.
    if (!contactValue || typeof contactValue !== "object") {
      return { nome: "", telefone: "", email: "" };
    }
    return {
      nome: contactValue.nome || contactValue.name || "",
      telefone:
        contactValue.telefone ||
        contactValue.phoneNumberFirst ||
        contactValue.phone ||
        "",
      email: contactValue.email || "",
    };
  };

  const contactToSelectValue = (contactValue) => {
    // Converte contato para string JSON com ordem fixa de chaves (nome, telefone, email).
    if (!contactValue || contactValue === "") return "";
    if (typeof contactValue === "string") {
      try {
        const parsed = JSON.parse(contactValue);
        return JSON.stringify(normalizeContactObject(parsed));
      } catch {
        return contactValue;
      }
    }
    return JSON.stringify(normalizeContactObject(contactValue));
  };

  const normalizeText = (value) => {
    // Normaliza strings para comparacoes sem diferenca de acento/caixa.
    return String(value || "")
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/\s+/g, " ")
      .trim()
      .toLowerCase();
  };

  const isBudgetOpenStatus = (statusValue) => {
    // Verifica se o orcamento esta com status "Em aberto", mesmo com variacoes de escrita.
    return normalizeText(statusValue) === "em aberto";
  };

  const isValidEmail = (emailValue) => {
    // Valida o formato basico de e-mail antes de tentar enviar.
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(emailValue || "").trim());
  };

  const toPdfFileToken = (value, fallback) => {
    // Sanitiza cada trecho do nome do PDF para manter padrao seguro no Storage/SO.
    const token = normalizeText(value)
      .toUpperCase()
      .replace(/[^A-Z0-9]+/g, "_")
      .replace(/^_+|_+$/g, "");
    return token || fallback;
  };

  const buildBudgetPdfFileName = (dadosPdf) => {
    // Padrao solicitado:
    // Orcamento_NOMEDOPAGADOR_ORIGEM_UF_DESTINO_UF_1770410579030.pdf
    const pagadorToken = toPdfFileToken(dadosPdf?.pagador, "SEM_PAGADOR");
    const origemUfToken = toPdfFileToken(dadosPdf?.origemUF, "SEM_ORIGEM");
    const destinoUfToken = toPdfFileToken(dadosPdf?.destinoUF, "SEM_DESTINO");
    return `Orcamento_${pagadorToken}_${origemUfToken}_${destinoUfToken}_${Date.now()}.pdf`;
  };

  const resolveSelectedContactEmail = (contactValue, contactsList = []) => {
    // Resolve o e-mail do contato selecionado com fallback para a lista completa de contatos do pagador.
    const directContact = extractContactData(contactValue);
    const directEmail = String(directContact?.email || "").trim();
    if (isValidEmail(directEmail)) return directEmail;

    if (typeof contactValue === "string") {
      const emailFromString = contactValue.match(/[^\s@]+@[^\s@]+\.[^\s@]+/);
      if (emailFromString?.[0] && isValidEmail(emailFromString[0])) {
        return emailFromString[0].trim();
      }
    }

    const normalizedName = normalizeText(directContact?.nome);
    const normalizedPhone = String(directContact?.telefone || "").replace(/\D/g, "");

    const matchedContact = (contactsList || []).find((contact) => {
      const normalizedContactName = normalizeText(contact?.nome || contact?.name);
      const normalizedContactPhone = String(
        contact?.telefone || contact?.phoneNumberFirst || contact?.phone || ""
      ).replace(/\D/g, "");

      const nameMatches =
        normalizedName &&
        normalizedContactName &&
        normalizedName === normalizedContactName;

      const phoneMatches =
        normalizedPhone &&
        normalizedContactPhone &&
        normalizedPhone === normalizedContactPhone;

      return nameMatches || phoneMatches;
    });

    const matchedEmail = String(matchedContact?.email || "").trim();
    return isValidEmail(matchedEmail) ? matchedEmail : "";
  };

  const getSellerContactData = () => {
    // Resolve nome, telefone e e-mail do vendedor para assinatura e Reply-To.
    const normalizedSellerName = normalizeText(seller);
    const sellerRecord = (sellersList || []).find(
      (item) => normalizeText(item?.name) === normalizedSellerName
    );

    return {
      nome: sellerRecord?.name || seller || users?.name || "-",
      telefone:
        sellerRecord?.phoneNumber ||
        sellerRecord?.phoneNumberFirst ||
        sellerRecord?.phone ||
        sellerRecord?.telefone ||
        users?.phoneNumber ||
        users?.phoneNumberFirst ||
        users?.phone ||
        users?.telefone ||
        "-",
      email: sellerRecord?.email || users?.email || "",
    };
  };

  const buildStopsDescriptionForPdf = (stops = []) => {
    const descriptions = (stops || [])
      .map((stop) =>
        String(stop?.descricao || stop?.description || stop?.Descricao || "").trim()
      )
      .filter(Boolean);

    return descriptions.length > 0
      ? descriptions.join(", ").toUpperCase()
      : "FRETE DEDICADO";
  };

  const buildBudgetPdfData = () => {
    // Monta os dados padrao do orcamento usados no PDF e no e-mail.
    const firstStop = formFields?.[0] || {};
    const lastStop = formFields?.[formFields.length - 1] || {};
    const pontosAdicionais = Math.max((formFields?.length || 0) - 2, 0);
    const vehicles = getSelectedNames(tipoVeículo);
    const bodyworks = getSelectedNames(typeBodyworkList);
    const itensPdf = (product || []).map((item, index) => ({
      item: index + 1,
      // Prioriza o nome selecionado na tabela de produtos para evitar fallback em "Servico".
      descricao:
        item?.nameProducts ||
        item?.description ||
        item?.descricao ||
        item?.name ||
        item?.nameProduct ||
        item?.typeService ||
        "Servico",
      qtd: Number(item?.quantity || item?.qtd || 1),
      valor: Number(item?.price || item?.value || item?.valor || item?.total || 0),
      total:
        Number(item?.total || 0) ||
        Number(item?.price || item?.value || item?.valor || 0) *
          Number(item?.quantity || item?.qtd || 1),
    }));
    const materiaisPdf = buildStopsDescriptionForPdf(formFields);
    const contato = extractContactData(selectedContact);
    const vendedorContato = getSellerContactData();

    return {
      firstStop,
      lastStop,
      contato,
      vendedorContato,
      dadosPdf: {
        numero: numberSerial || "-",
        dataOrcamento: Utils.formatDateBR(new Date()),
        pagador: payingCustomer || "-",
        vendedor: vendedorContato.nome,
        contatoNome: contato.nome !== "-" ? contato.nome : vendedorContato.nome,
        contatoTelefone: contato.telefone,
        contatoEmail: contato.email,
        origemCidade: firstStop.city || "-",
        origemUF: firstStop.uf || "-",
        destinoCidade: lastStop.city || "-",
        destinoUF: lastStop.uf || "-",
        pontosAdicionais,
        previsao: Utils.formatDateBR(deliveryDeadline),
        modal: occupation || "-",
        veiculo: vehicles.length ? vehicles.join(", ") : "-",
        carroceria: bodyworks.length ? bodyworks.join(", ") : "-",
        peso: weightCargo ? `${weightCargo} kg` : "-",
        valorTransportado: valueNF ? formatCurrencyBRL(valueNF) : "-",
        materiais: materiaisPdf,
        descricaoServicos: "FRETE DEDICADO.",
        valorFrete: formatCurrencyBRL(valueFreightage),
        total: formatCurrencyBRL(valueFreightage),
        prazoPagamento: paymentCondition || "-",
        observacoes: observation || "-",
        itens: itensPdf,
      },
    };
  };

  const buildBudgetEmailTemplate = ({ pagadorNome, origem, destino, clienteNome, vendedor }) => {
    // Monta assunto e corpo de e-mail conforme o modelo de apresentacao do orcamento.
    const subject = `Orcamento - ${pagadorNome} - Frete ${origem} para ${destino}`;

    const html = `
      <div style="font-family: Arial, sans-serif; color: #111; line-height: 1.5;">
        <p>Prezado(a) ${clienteNome},</p>
        <p>Conforme solicitado, segue em anexo o or&ccedil;amento referente ao servi&ccedil;o de transporte.</p>
        <p>Ficamos &agrave; disposi&ccedil;&atilde;o para esclarecer qualquer d&uacute;vida ou realizar eventuais ajustes que sejam necess&aacute;rios. Assim que aprovado, poderemos dar andamento &agrave; programa&ccedil;&atilde;o do servi&ccedil;o.</p>
        <p>Agradecemos pela oportunidade.</p>
        <br />
        <p>Atenciosamente,</p>
        <p>${vendedor.nome}<br />Fortio Transportes<br />${vendedor.telefone}<br />${vendedor.email || "-"}</p>
      </div>
    `;

    return { subject, html };
  };

  const normalizePhoneToWhatsapp = (phoneValue) => {
    // Normaliza telefone para formato aceito pelo wa.me (somente digitos com DDI 55).
    const digits = String(phoneValue || "").replace(/\D/g, "");
    if (!digits) return "";
    return digits.startsWith("55") ? digits : `55${digits}`;
  };

  const buildBudgetWhatsAppMessage = ({ dadosPdf }) => {
    // Monta mensagem padrao de cotacao para WhatsApp.
    const origem = `${dadosPdf.origemCidade || "-"} - ${dadosPdf.origemUF || "-"}`;
    const destino = `${dadosPdf.destinoCidade || "-"} - ${dadosPdf.destinoUF || "-"}`;
    const mercadoriaTransportada = Array.isArray(dadosPdf.itens) && dadosPdf.itens.length
      ? dadosPdf.itens
          .map((item) => String(item?.descricao || "").trim())
          .filter(Boolean)
          .join(", ")
      : (dadosPdf.materiais || "-");
    const veiculoCarroceria = [dadosPdf.veiculo, dadosPdf.carroceria]
      .filter((value) => String(value || "").trim() && value !== "-")
      .join(" / ") || "-";

    return [
      `Prezado(a), ${dadosPdf.contatoNome || "-"}`,
      "",
      `Conforme nossa conversa e conforme solicitado, estou encaminhando o orçamento referente ao serviço de transporte no trecho ${origem} para ${destino}.`,
      "",
      "Cotação de Frete",
      `Origem: ${origem}`,
      `Destino: ${destino}`,
      `Modalidade: ${dadosPdf.modal || "-"}`,
      `Veículo/Carroceria: ${veiculoCarroceria}`,
      `Prazo de Entrega: ${dadosPdf.previsao || "-"}`,
      `Mercadoria Transportada: ${mercadoriaTransportada || "-"}`,
      `Valor da Mercadoria: ${dadosPdf.valorTransportado || "-"}`,
      `Peso Transportado: ${dadosPdf.peso || "-"}`,
      `Valor Total: ${dadosPdf.total || "-"}`,
      `Condição de Pagamento: ${dadosPdf.prazoPagamento || "-"}`,
      `Pagador: ${dadosPdf.pagador || "-"}`,
      `Observações: ${dadosPdf.observacoes || "-"}`,
      "",
      "Fico à disposição para esclarecer qualquer dúvida ou ajustar o que for necessário para atendê-lo da melhor forma possível.",
      "",
      "Atenciosamente,",
      `${dadosPdf.vendedor || "-"}`,
      "Fortio Transportes",
    ].join("\n");
  };

  const uploadBudgetPdfAndGetPublicUrl = async ({ budgetId, fileName, pdfBase64 }) => {
    // Publica o PDF no Firebase Storage e retorna URL + path para referencia no e-mail.
    const storagePath = `budget/${budgetId}/attachments/${fileName}`;
    const storageRef = ref(storage, storagePath);
    await uploadString(storageRef, pdfBase64, "base64", {
      contentType: "application/pdf",
    });
    const pdfUrl = await getDownloadURL(storageRef);
    return { pdfUrl, storagePath };
  };

  async function sendBudgetPdfByWhatsApp() {
    // Salva orçamento, gera PDF, cria URL pública e abre mensagem automática no WhatsApp.
    try {
      setCarregando(1);
      const savedBudgetId = await save({ redirect: false });
      if (!savedBudgetId) return;

      const { contato, dadosPdf } = buildBudgetPdfData();
      const whatsappPhone = normalizePhoneToWhatsapp(contato?.telefone);
      const fileName = buildBudgetPdfFileName(dadosPdf);

      if (!whatsappPhone) {
        setTitle("Telefone não cadastrado");
        setMsg("Envio via WhatsApp indisponível. O embarcador não possui telefone cadastrado. Cadastre um número para continuar.");
        setOpen(true);
        setCarregando(0);
        return;
      }

      const pdfBase64 = await gerarPdfOrcamento(dadosPdf, { output: "base64" });
      const sanitizedPdfBase64 = String(pdfBase64 || "")
        .replace(/^data:application\/pdf;base64,/, "")
        .trim();

      if (!sanitizedPdfBase64 || sanitizedPdfBase64.length < 100) {
        throw new Error("Falha ao gerar PDF em base64 para WhatsApp.");
      }

      await uploadBudgetPdfAndGetPublicUrl({
        budgetId: savedBudgetId,
        fileName,
        pdfBase64: sanitizedPdfBase64,
      });

      // Tambem faz o download local do PDF ao enviar pelo WhatsApp.
      await gerarPdfOrcamento(dadosPdf, { fileName });

      const message = buildBudgetWhatsAppMessage({ dadosPdf });
      let copiedToClipboard = false;
      try {
        if (navigator?.clipboard?.writeText) {
          await navigator.clipboard.writeText(message);
          copiedToClipboard = true;
        }
      } catch (clipboardError) {
        console.warn("[BudgetWhatsApp] Falha ao copiar mensagem para area de transferencia.", clipboardError);
      }
      const whatsappUrl = `https://wa.me/${whatsappPhone}?text=${encodeURIComponent(message)}`;
      window.open(whatsappUrl, "_blank", "noopener,noreferrer");

      await db.collection("tb_budget").doc(savedBudgetId).update({
        status: {
          describe: "Enviado",
          code: "02",
        },
      });

      setStatus("Enviado");
      setCode("02");
      setCanApprove(true);
      setTitle("Sucesso");
      setMsg(
        copiedToClipboard
          ? "Mensagem formatada copiada para a area de transferencia e WhatsApp aberto."
          : "WhatsApp aberto com a mensagem formatada da cotacao."
      );
      setOpen(true);
      setCarregando(0);
    } catch (error) {
      console.error("Erro ao enviar orçamento por WhatsApp:", error);
      setCarregando(0);
      showMessage("Erro ao preparar envio do orçamento por WhatsApp.");
    }
  }

  async function sendBudgetPdfByEmail() {
    // Salva o orçamento, envia e-mail com referência do PDF e altera automaticamente o status para "Enviado".

    try {
      setCarregando(1);
      const savedBudgetId = await save({ redirect: false });
      if (!savedBudgetId) return;

      const { firstStop, lastStop, contato, vendedorContato, dadosPdf } = buildBudgetPdfData();
      const emailContato = resolveSelectedContactEmail(selectedContact, shipperContacts);
      const fileName = buildBudgetPdfFileName(dadosPdf);

      if (!isValidEmail(emailContato)) {
        setTitle("E-mail não cadastrado");
        setMsg("O embarcador não tem e-mail cadastrado para envio do PDF. Corrija o cadastro do contato e tente novamente.");
        setOpen(true);
        setCarregando(0);
        return;
      }

      const origemFrete = `${firstStop?.city || "-"} - ${firstStop?.uf || "-"}`;
      const destinoFrete = `${lastStop?.city || "-"} - ${lastStop?.uf || "-"}`;
      const emailTemplate = buildBudgetEmailTemplate({
        pagadorNome: payingCustomer || "-",
        origem: origemFrete,
        destino: destinoFrete,
        clienteNome: contato?.nome && contato.nome !== "-" ? contato.nome : "Cliente",
        vendedor: vendedorContato,
      });

      // Gera o PDF e publica no Storage para enviar apenas referencia ao backend.
      const pdfBase64 = await gerarPdfOrcamento(dadosPdf, { output: "base64" });
      const sanitizedPdfBase64 = String(pdfBase64 || "")
        .replace(/^data:application\/pdf;base64,/, "")
        .trim();

      if (!sanitizedPdfBase64 || sanitizedPdfBase64.length < 100) {
        throw new Error("Falha ao gerar PDF para envio por e-mail.");
      }

      const { pdfUrl, storagePath } = await uploadBudgetPdfAndGetPublicUrl({
        budgetId: savedBudgetId,
        fileName,
        pdfBase64: sanitizedPdfBase64,
      });

      const htmlWithPublicUrl = `
        ${emailTemplate.html}
        <p>Acesse o or&ccedil;amento pelo link:</p>
        <p>
          <a
            href="${pdfUrl}"
            target="_blank"
            rel="noreferrer noopener"
            style="display:inline-block;padding:10px 16px;background:#012443;color:#ffffff;text-decoration:none;border-radius:6px;font-weight:600;"
          >
            Abrir or&ccedil;amento
          </a>
        </p>
      `;

      console.log("[BudgetEmail] PDF publicado no Storage com sucesso", {
        budgetId: savedBudgetId,
        storagePath,
      });

      let responseEmail = null;
      try {
        responseEmail = await emailServiceBudget.sendEmailBudget({
          to: emailContato,
          subject: emailTemplate.subject,
          html: htmlWithPublicUrl,
          replyTo: isValidEmail(vendedorContato.email) ? vendedorContato.email : undefined,
          attachmentRefs: [
            {
              filename: fileName,
              url: pdfUrl,
              storagePath,
              contentType: "application/pdf",
            },
          ],
          attachments: [],
        });

        if (!responseEmail?.success) {
          throw new Error(responseEmail?.message || "Falha no envio do e-mail com anexo server-side.");
        }
      } catch (attachmentError) {
        console.warn("[BudgetEmail] Falha no envio com attachmentRefs. Enviando somente com link publico.", attachmentError);

        responseEmail = await emailServiceBudget.sendEmailBudget({
          to: emailContato,
          subject: emailTemplate.subject,
          html: htmlWithPublicUrl,
          replyTo: isValidEmail(vendedorContato.email) ? vendedorContato.email : undefined,
          attachments: [],
          attachmentRefs: [],
        });

        if (!responseEmail?.success) {
          throw new Error(responseEmail?.message || "Falha no envio do e-mail com URL publica.");
        }
      }

      await db.collection("tb_budget").doc(savedBudgetId).update({
        status: {
          describe: "Enviado",
          code: "02",
        },
      });

      setStatus("Enviado");
      setCode("02");
      setCanApprove(true);
      setTitle("Sucesso");
      setMsg("Orçamento enviado por e-mail com sucesso.");
      setOpen(true);
      setCarregando(0);
    } catch (error) {
      console.error("Erro ao enviar e-mail do orçamento:", error);
      setCarregando(0);
      setTitle("Erro no envio");
      setMsg(error?.message || "Não foi possível enviar o orçamento por e-mail.");
      setOpen(true);
    }
  }
  async function saveAndEmitPdfV2() {
    // Salva o orçamento, gera o PDF de apresentação e atualiza o status para "Enviado".
    try {
      const savedBudgetId = await save({ redirect: false });
      if (!savedBudgetId) return;

      const firstStop = formFields?.[0] || {};
      const lastStop = formFields?.[formFields.length - 1] || {};
      const pontosAdicionais = Math.max((formFields?.length || 0) - 2, 0);
      const vehicles = getSelectedNames(tipoVeículo);
      const bodyworks = getSelectedNames(typeBodyworkList);
      const itensPdf = (product || []).map((item, index) => ({
        item: index + 1,
        // Prioriza o nome selecionado na tabela de produtos para evitar fallback em "Servico".
        descricao:
          item?.nameProducts ||
          item?.description ||
          item?.descricao ||
          item?.name ||
          item?.nameProduct ||
          item?.typeService ||
          "Servico",
        qtd: Number(item?.quantity || item?.qtd || 1),
        valor: Number(item?.price || item?.value || item?.valor || item?.total || 0),
        total:
          Number(item?.total || 0) ||
          Number(item?.price || item?.value || item?.valor || 0) *
            Number(item?.quantity || item?.qtd || 1),
      }));
      const materiaisPdf = buildStopsDescriptionForPdf(formFields);
      const contato = extractContactData(selectedContact);

      const dadosPdf = {
        numero: numberSerial || "-",
        dataOrcamento: Utils.formatDateBR(new Date()),
        pagador: payingCustomer || "-",
        vendedor: seller || users?.name || "-",
        contatoNome: contato.nome !== "-" ? contato.nome : (seller || users?.name || "-"),
        contatoTelefone: contato.telefone,
        contatoEmail: contato.email,
        origemCidade: firstStop.city || "-",
        origemUF: firstStop.uf || "-",
        destinoCidade: lastStop.city || "-",
        destinoUF: lastStop.uf || "-",
        pontosAdicionais,
        previsao: Utils.formatDateBR(deliveryDeadline),
        modal: occupation || "-",
        veiculo: vehicles.length ? vehicles.join(", ") : "-",
        carroceria: bodyworks.length ? bodyworks.join(", ") : "-",
        peso: weightCargo ? `${weightCargo} kg` : "-",
        valorTransportado: valueNF ? formatCurrencyBRL(valueNF) : "-",
        materiais: materiaisPdf,
        descricaoServicos: "FRETE DEDICADO.",
        valorFrete: formatCurrencyBRL(valueFreightage),
        total: formatCurrencyBRL(valueFreightage),
        prazoPagamento: paymentCondition || "-",
        observacoes: observation || "-",
        itens: itensPdf,
      };

      // Aplica o mesmo padrao de nome tambem no download direto do PDF.
      const fileName = buildBudgetPdfFileName(dadosPdf);
      await gerarPdfOrcamento(dadosPdf, { fileName });

      await db.collection("tb_budget").doc(savedBudgetId).update({
        status: {
          describe: "Enviado",
          code: "02",
        },
      });

      setStatus("Enviado");
      setCode("02");
      setCanApprove(true);
      setCarregando(0);
      navigate("/orcamento/listagem");
    } catch (error) {
      console.error("Erro ao emitir PDF do orçamento:", error);
      setCarregando(0);
      showMessage("Erro ao emitir PDF do orçamento");
    }
  }

  const currencyConfig = {
    locale: "pt-BR",
    formats: {
      number: {
        BRL: {
          style: "currency",
          currency: "BRL",
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        },
      },
    },
  };

  const weightConfig = {
    locale: "pt-BR",
    formats: {
      number: {
        BRL: {
          style: "decimal",
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        },
      },
    },
  };

  const formatName = (name) => {
    if (!name) return "";
    return name
      .toLowerCase()
      .split(" ")
      .map((word) => {
        return word.charAt(0).toUpperCase() + word.slice(1);
      })
      .join(" ");
  };

  const handleChangeWeightCargo = (event, value, maskedValue) => {
    setWeightCargo(value);
  };

  const handleChangeValueNF = (event, value, maskedValue) => {
    setValueNF(value);
  };

  const handleChangeValueFreightage = (event, value, maskedValue) => {
    setValueFreightage(value);
  };

  const handleChangePaymentCondition = (event) => {
    setPaymentCondition(event.target.value);
  };

  return (
    <>
      {useSelector((state) => state.usuarioLogado) > 0 ? (
        <NewMiniDrawer
          divOpen={
            <Box
              component="span"
              sx={{
                display: "inline-block",
                mx: "1px",
                transform: "scale(1.0)",
              }}
            >
              <div
                className="freight-content align-items-center"
                style={{ paddingTop: "0px" }}
              >
                {/* Dialogs */}
                <AlertDialogFreight
                  handleClose={handleCloseModal}
                  open={openOrigem}
                  origem={origem}
                  handleUpload={handleUpload}
                  operationType={currentOperationType}
                />

                <ShipperDialog
                  handleClose={handleShipperCloseModal}
                  open={openShipper}
                  dadosClient={getDadaClient}
                />

                {/* Cabecalho */}
                <div className="container">
                  <div className="row">
                    <div className="col-5">
                      <p className="help-block">
                        Número Orçamento: <strong>{numberSerial}</strong>
                      </p>
                    </div>

                    <div className="col-5" />

                    <div className="col-2">
                      <div className="col-md-11 control-label">
                        <p className="help-block">
                          <span className="h11">*</span>
                          <strong> Campo Obrigatório </strong>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Stepper usando o STATUS do outro bloco */}
                <div className="row g-12">
                  <div role="group" aria-label="Status do orçamento">
                    <ModernStepper
                      propsStatus={code}
                      onStatusConfirm={handleStatusStepperConfirm}
                    />
                  </div>

                  <hr className="my-4" />
                </div>

                <div className="container">
                  {/* Pagador */}
                  <Card
                    sx={{ padding: 2 }}
                    className="form-signin mx-auto mb-4 mb-lg-6 border border-[10px] border-[#001f3f] rounded-lg p-3"
                    style={{
                      background: "#ffffff",
                      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.15)",
                      borderRadius: "16px",
                    }}
                  >
                    <div className="form-signin mx-auto mb-4 mb-lg-6">
                      <h4
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "4px",
                        }}
                        className="mb-3"
                      >
                        <PersonIcon fontSize="medium" /> Pagador
                      </h4>

                      <div className="row justify-content-center align-items-center gx-3">
                        {/* Pagador */}
                        <div className="col-4">
                          <label htmlFor="payingCustomerLabel" className="font-test">
                            Pagador <span style={{ color: "red" }}>*</span>
                          </label>

                          <Autocomplete
                            id="payingCustomer"
                            size="small"
                            value={listECShipper && listECShipper}
                            options={listShipper}
                            getOptionLabel={(option) =>
                              option?.dataPersonal?.socialName ||
                              option?.dataPersonal?.nameFantasy ||
                              ""
                            }
                            isOptionEqualToValue={(option, value) =>
                              option?.dataPersonal?.socialName === value?.dataPersonal?.socialName
                            }
                            onChange={(event, value) => {
                              handleChangeShipper(value);

                              // segue a mesma ideia do outro card:
                              // salva o nome para exibir e manter consistencia
                              setPayingCustomer(value?.dataPersonal?.socialName || "");
                            }}
                            noOptionsText="Nenhum Embarcador com esse nome foi encontrado"
                            sx={{ width: "100%" }}
                            renderInput={(params) => <TextField {...params} label="" />}
                          />
                        </div>

                        {/* CNPJ */}
                        <div className="col-md-3">
                          <label htmlFor="cnpjPayingCustomerLabel" className="font-test">
                            CNPJ <span style={{ color: "red" }}>*</span>
                          </label>

                          <InputMask
                            mask="99.999.999/9999-99"
                            value={cnpjPayingCustomer || ""}
                            disabled
                          >
                            {(inputProps) => (
                              <TextField
                                {...inputProps}
                                id="cnpjPayingCustomer"
                                size="small"
                                fullWidth
                              />
                            )}
                          </InputMask>
                        </div>

                        {/* Contato */}
                        <div className="col-md-3">
                          <label htmlFor="contactLabel" className="font-test">
                            Contato <span style={{ color: "red" }}>*</span>
                          </label>

                          <Select
                            value={contactToSelectValue(selectedContact)}
                            onChange={(e) => {
                              const value = e.target.value;
                              if (value === "") {
                                setSelectedContact("");
                              } else {
                                try {
                                  const parsed = JSON.parse(value);
                                  setSelectedContact(normalizeContactObject(parsed));
                                } catch {
                                  setSelectedContact(value);
                                }
                              }
                            }}
                            fullWidth
                            size="small"
                            displayEmpty
                            renderValue={(value) => {
                              if (!value || value === "") return "Selecione um contato";
                              if (typeof value === "string") {
                                try {
                                  const parsed = JSON.parse(value);
                                  const parts = [];
                                  if (parsed.nome) parts.push(parsed.nome);
                                  if (parsed.telefone) parts.push(parsed.telefone);
                                  if (parsed.email) parts.push(parsed.email);
                                  return parts.length > 0 ? parts.join(" - ") : value;
                                } catch {
                                  return value;
                                }
                              }
                              // Se for objeto, exibir nome, telefone e email
                              const contact = value;
                              const parts = [];
                              if (contact.nome) parts.push(contact.nome);
                              if (contact.telefone) parts.push(contact.telefone);
                              if (contact.email) parts.push(contact.email);
                              return parts.length > 0 ? parts.join(" - ") : "Contato";
                            }}
                          >
                            <MenuItem value="">Selecione um contato</MenuItem>
                            {shipperContacts.map((contact, index) => {
                              // Normaliza contato para manter consistencia entre option e value do Select.
                              const normalizedContact =
                                typeof contact === "object" && contact !== null
                                  ? normalizeContactObject(contact)
                                  : {
                                    nome: "",
                                    telefone: String(contact || ""),
                                    email: "",
                                  };

                              const contactValue = JSON.stringify(normalizedContact);

                              return (
                                <MenuItem key={index} value={contactValue}>
                                  <div style={{ display: "flex", flexDirection: "column", gap: "2px" }}>
                                    {normalizedContact.nome && (
                                      <strong style={{ fontSize: "0.95em" }}>{normalizedContact.nome}</strong>
                                    )}
                                    <div style={{ fontSize: "0.85em", color: "#666" }}>
                                      {normalizedContact.telefone && (
                                        <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                                          <PhoneIcon fontSize="small" /> {normalizedContact.telefone}
                                        </div>
                                      )}
                                      {normalizedContact.email && (
                                        <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                                          <EmailIcon fontSize="small" /> {normalizedContact.email}
                                        </div>
                                      )}
                                      {!normalizedContact.telefone && !normalizedContact.email && !normalizedContact.nome && "Contato"}
                                    </div>
                                  </div>
                                </MenuItem>
                              );
                            })}
                          </Select>
                        </div>
                      </div>
                    </div>
                  </Card>


                  {/* Pontos de Parada */}
                  <Card
                    sx={{ padding: 2, marginBottom: 2 }}
                    className="form-signin mx-auto mb-4 border border-[10px] border-[#001f3f] rounded-lg p-3"
                    style={{
                      background: "#ffffff",
                      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.15)",
                      borderRadius: "16px",
                      width: "100%",
                    }}
                  >
                    <h4 className="mb-3">
                      <LocationOnIcon className="localShippingIcon" /> Pontos de Parada
                    </h4>

                    {formFields.map((form, index) => {
                      const indiceReal = index;

                      return (
                        <Box key={index} sx={{ marginBottom: 2 }}>
                          <Card
                            className="form-signin mx-auto mb-4  mb-lg-6 border border-[10px] border-[#001f3f] rounded-lg p-3 align-items-center"
                            style={{
                              background: form.canhoto ? "#f2f8fb" : "#ffffff",
                              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.15)",
                              borderRadius: "16px",
                            }}
                          >
                            <div className="row mb-5">
                              <Spin spinning={loading} size="Large">
                                {/* LINHA 1 */}
                                <div className="row">
                                  <div className="col-1 mb-4">
                                    <label htmlFor="ordenacaoLabel" className="font-test">
                                      Ordenação
                                    </label>
                                    <input
                                      disabled={view}
                                      type="number"
                                      name="stop_order"
                                      min={1}
                                      onChange={(event) => handleFormChange(event, indiceReal)}
                                      value={form.stop_order && form.stop_order}
                                      size={"small"}
                                      className="form-control"
                                      id="ordenacao"
                                      placeholder=""
                                    />
                                  </div>

                                  <div className="col-1 mb-2"></div>

                                  <div className="col-3 mb-2">
                                    <FormControl component="fieldset">
                                      <FormLabel id="demo-row-radio-buttons-group-label">
                                        <label className="font-test">
                                          Tipo de Parada <span style={{ color: "red" }}>*</span>
                                        </label>
                                      </FormLabel>

                                      <div className="row">
                                        <div className="col-6 mb-2">
                                          <FormControlLabel
                                            disabled={view}
                                            value="carga"
                                            name="carga"
                                            onChange={(event) => {
                                              handleFormChange(event, indiceReal, "carga");
                                              handleNameButtonImport("carga");
                                              handleCheckBoxChange(event, indiceReal);
                                            }}
                                            control={
                                              <Checkbox
                                                value={form.operation[0] && form.operation[0]}
                                                checked={form.operation.includes("carga")}
                                                disabled={form.operation.includes("descarga")}
                                              />
                                            }
                                            label="Carga"
                                          />
                                        </div>

                                        <div className="col-6 mb-2">
                                          <FormControlLabel
                                            disabled={view}
                                            value="descarga"
                                            name="descarga"
                                            onChange={(event) => {
                                              handleFormChange(event, indiceReal, "descarga");
                                              handleNameButtonImport("descarga");
                                              handleCheckBoxChange(event, indiceReal);
                                            }}
                                            control={
                                              <Checkbox
                                                value={form.operation[1] && form.operation[1]}
                                                checked={form.operation.includes("descarga")}
                                                disabled={form.operation.includes("carga")}
                                              />
                                            }
                                            label="Descarga"
                                          />
                                        </div>
                                      </div>
                                    </FormControl>
                                  </div>

                                  <div className="col-6 mb-2">
                                    <FormGroup>{/* reservado */}</FormGroup>
                                  </div>

                                  {/* Botoes (duplicar/excluir) */}
                                  <div className="col-1 mb-2" direction="row">
                                    <div>
                                      <FormGroup>
                                        <Stack spacing={1}>
                                          <IconButton
                                            disabled={view}
                                            size="large"
                                            onClick={() => duplicateForm(indiceReal)}
                                            color="primary"
                                            aria-label="duplicate"
                                          >
                                            <ContentCopyIcon />
                                          </IconButton>
                                        </Stack>
                                      </FormGroup>
                                    </div>

                                    <div>
                                      <FormGroup>
                                        <Stack spacing={1}>
                                          <IconButton
                                            disabled={view}
                                            size="large"
                                            onClick={(e) => deleteItem(form, indiceReal)}
                                            color="error"
                                            aria-label="delete"
                                          >
                                            <DeleteForeverIcon />
                                          </IconButton>
                                        </Stack>
                                      </FormGroup>
                                    </div>
                                  </div>
                                </div>

                                {/* LINHA 2 */}
                                <div className="row">
                                  <div className="col-4">
                                    <label htmlFor="cnpjLabel" className="font-test">
                                      CNPJ <span style={{ color: "red" }}>*</span>
                                    </label>
                                    <input
                                      disabled={view}
                                      type="text"
                                      name="cpf_cnpj"
                                      onChange={(event) => {
                                        buscarCNPJBancoClient(event.target.value, indiceReal);
                                        handleFormChange(event, indiceReal);
                                      }}
                                      value={form.cpf_cnpj && form.cpf_cnpj}
                                      className="form-control"
                                      id="cnpj"
                                      placeholder=""
                                    />
                                  </div>

                                  <div className="col-8">
                                    <label htmlFor="nomeLabel" className="font-test">
                                      Nome <span style={{ color: "red" }}>*</span>
                                    </label>
                                    <input
                                      disabled={view}
                                      type="text"
                                      name="name"
                                      onChange={(event) => handleFormChange(event, indiceReal)}
                                      value={form.name && form.name}
                                      className="form-control"
                                      id="name"
                                      placeholder=""
                                    />
                                  </div>
                                </div>

                                {/* LINHA 3 */}
                                <div className="row">
                                  <div className="col-2">
                                    <label htmlFor="cepLabel" className="font-test">
                                      CEP <span style={{ color: "red" }}>*</span>
                                    </label>
                                    <input
                                      disabled={view}
                                      type="text"
                                      name="cep"
                                      onChange={(event) => {
                                        handleFormChange(event, indiceReal);

                                        const rawValue = event.target.value.replace(/\D/g, "");
                                        if (rawValue.length === 8) {
                                          buscarCepPaying(rawValue, indiceReal);
                                        }
                                      }}
                                      value={form.cep || ""}
                                      maxLength={9}
                                      className="form-control"
                                      id="cep"
                                    />
                                  </div>

                                  <div className="col-md-4">
                                    <label htmlFor="addressLabel" className="font-test">
                                      Endereço <span style={{ color: "red" }}>*</span>
                                    </label>
                                    <input
                                      disabled={view}
                                      type="text"
                                      name="logradouro"
                                      onChange={(event) => handleFormChange(event, indiceReal)}
                                      value={form.logradouro && form.logradouro}
                                      className="form-control"
                                      id="address"
                                    />
                                  </div>

                                  <div className="col-md-1">
                                    <label htmlFor="numberLabel" className="font-test">
                                      N.o <span style={{ color: "red" }}>*</span>
                                    </label>
                                    <input
                                      disabled={view}
                                      type="text"
                                      name="number"
                                      onChange={(event) => {
                                        handleFormChange(event, indiceReal);
                                        consultStreetByStreet(indiceReal);
                                      }}
                                      value={form.number && form.number}
                                      className="form-control"
                                      id="numberAddress"
                                    />
                                  </div>

                                  <div className="col-2">
                                    <label htmlFor="city" className="font-test">
                                      Cidade <span style={{ color: "red" }}>*</span>
                                    </label>
                                    <input
                                      disabled={view}
                                      type="text"
                                      name="city"
                                      onChange={(event) => handleFormChange(event, indiceReal)}
                                      value={form.city && form.city}
                                      className="form-control"
                                      id="cityAddress"
                                      placeholder=""
                                    />
                                  </div>

                                  <div className="col-md-1">
                                    <label htmlFor="stateInitialLabel" className="font-test">
                                      Estado <span style={{ color: "red" }}>*</span>
                                    </label>
                                    <input
                                      disabled={view}
                                      type="text"
                                      name="uf"
                                      onChange={(event) => handleFormChange(event, indiceReal)}
                                      value={form.uf && form.uf}
                                      className="form-control"
                                      id="stateInitial"
                                    />
                                  </div>

                                  <div className="col-md-2">
                                    <label htmlFor="stateInitialLabel" className="font-test">
                                      Atualizar
                                    </label>

                                    {form.checkItemLocation ? (
                                      <Stack direction="row">
                                        <Button
                                          disabled={view}
                                          variant="contained"
                                          size="small"
                                          onClick={() => consultStreetByStreet(indiceReal)}
                                          color="success"
                                          startIcon={<CheckCircleOutlineIcon />}
                                        >
                                          Atualizado!
                                        </Button>
                                      </Stack>
                                    ) : (
                                      <Stack direction="row">
                                        <Button
                                          disabled={view}
                                          sx={{ backgroundColor: "#012443" }}
                                          variant="contained"
                                          size="small"
                                          onClick={() => consultStreetByStreet(indiceReal)}
                                          color="primary"
                                          startIcon={<LoopIcon />}
                                        >
                                          Atualizar
                                        </Button>
                                      </Stack>
                                    )}
                                  </div>
                                </div>

                                {/* LINHA 4 */}
                                <div className="row">
                                  <div className="col-md-3">
                                    <label htmlFor="responsibleLabel" className="font-test">
                                      Responsável
                                    </label>
                                    <input
                                      disabled={view}
                                      type="text"
                                      name="responsible_name"
                                      onChange={(event) => handleFormChange(event, indiceReal)}
                                      value={form.responsible_name && form.responsible_name}
                                      className="form-control"
                                      id="responsible"
                                    />
                                  </div>

                                  <div className="col-3">
                                    <label htmlFor="phoneRespLabel" className="font-test">
                                      Telefone Responsável
                                    </label>
                                    <InputMask
                                      disabled={view}
                                      mask="(99) 99999-9999"
                                      id="phoneResp"
                                      className="form-control"
                                      name="responsible_phone"
                                      onChange={(event) => handleFormChange(event, indiceReal)}
                                      value={form.responsible_phone && form.responsible_phone}
                                      placeholder="(99) 99999-9999"
                                    />
                                  </div>

                                  <div className="col-md-2">
                                    <label htmlFor="numberColetaLabel" className="font-test" style={{ whiteSpace: "nowrap" }}>
                                      Número da coleta <span style={{ color: "red" }}>*</span>
                                    </label>
                                    <input
                                      disabled={view}
                                      readOnly
                                      type="text"
                                      name="number_collect"
                                      onChange={(event) => handleFormChange(event, indiceReal)}
                                      value={form.number_collect && form.number_collect}
                                      className="form-control"
                                      id="numbercoleta"
                                    />
                                  </div>

                                  <div className="col-md-2 mb-4">
                                    <label htmlFor="datacoletaLabel" className="font-test">
                                      Data da Coleta
                                    </label>
                                    <input
                                      disabled={view}
                                      type="date"
                                      name="date_operation"
                                      onChange={(event) => handleFormChange(event, indiceReal)}
                                      value={form.date_operation || ""}
                                      className="form-control"
                                      id="datacoleta"
                                    />
                                  </div>

                                  <div className="col-md-2 mb-4">
                                    <label htmlFor="horacoletaLabel" className="font-test">
                                      Hora da Coleta
                                    </label>
                                    <InputMask
                                      disabled={view}
                                      mask="99:99"
                                      id="time_operation"
                                      className="form-control"
                                      name="time_operation"
                                      onChange={(event) => handleFormChange(event, indiceReal)}
                                      value={form.time_operation && form.time_operation}
                                      placeholder="99:99"
                                    />
                                  </div>
                                </div>

                                {/* Latitude / Longitude */}
                                <div className="row">
                                  <div className="col-md-3 mb-2">
                                    <label htmlFor="Latitude" className="font-test">
                                      Latitude
                                    </label>
                                    <input
                                      type="text"
                                      name="latitude"
                                      disabled={!form.manualCoordinatesEnabled}
                                      value={form.latitude || ""}
                                      className="form-control"
                                      id="latitude"
                                      onChange={(event) => handleFormChange(event, indiceReal)}
                                      readOnly={!form.manualCoordinatesEnabled}
                                    />
                                  </div>

                                  <div className="col-md-3 mb-4">
                                    <label htmlFor="Longitude" className="font-test">
                                      Longitude
                                    </label>
                                    <input
                                      type="text"
                                      name="longitude"
                                      disabled={!form.manualCoordinatesEnabled}
                                      value={form.longitude || ""}
                                      className="form-control"
                                      id="longitude"
                                      onChange={(event) => handleFormChange(event, indiceReal)}
                                      readOnly={!form.manualCoordinatesEnabled}
                                    />
                                  </div>

                                  {/* Tipo + Descrição quando carga */}
                                  {form.operation.includes("carga") && (
                                    <>
                                      <div className="col-md-2 mb-4">
                                        <label htmlFor="Tipo" className="font-test">
                                          Tipo
                                        </label>
                                        <select
                                          disabled={view}
                                          className="form-select"
                                          onChange={(e) => {
                                            const value = e.target.value || "";
                                            setFormFields((prev) => {
                                              const newFormFields = [...prev];
                                              newFormFields[indiceReal].type = value;
                                              return newFormFields;
                                            });
                                          }}
                                          value={form.type && form.type}
                                        >
                                          <option defaultValue="">Selecione</option>
                                          <option value="01">01 - Granel Solido</option>
                                          <option value="02">02 - Granel liquido</option>
                                          <option value="03">03 - Frigorificada</option>
                                          <option value="04">04 - Conteinerizada</option>
                                          <option value="05">05 - Carga Geral</option>
                                          <option value="06">06 - Neogranel</option>
                                          <option value="07">07 - Perigosa (granel solido)</option>
                                          <option value="08">08 - Perigosa (granel liquido)</option>
                                          <option value="09">09 - Perigosa (carga frigorificada)</option>
                                          <option value="10">10 - Perigosa (conteinerizada)</option>
                                          <option value="11">11 - Perigosa (carga geral)</option>
                                        </select>
                                      </div>

                                      <div className="col-md-3 mb-4">
                                        <label htmlFor="descricao" className="font-test">
                                          Descrição
                                        </label>
                                        <input
                                          disabled={view}
                                          type="text"
                                          name="descricao"
                                          className="form-control"
                                          value={form.descricao && form.descricao}
                                          onChange={(e) => {
                                            const value = e.target.value || "";
                                            setFormFields((prev) => {
                                              const newFormFields = [...prev];
                                              newFormFields[indiceReal].descricao = value;
                                              return newFormFields;
                                            });
                                          }}
                                          placeholder="Descrição do ponto"
                                        />
                                      </div>
                                    </>
                                  )}
                                </div>

                                {/* Geoposicao / Ver no mapa */}
                                <div className="row">
                                  <div className="col-md-3 mb-4">
                                    <div className="d-flex align-items-center" style={{ height: "0px" }}>
                                      <label htmlFor="Geoposicao" className="font-test ">
                                        Informar Geolocalização
                                      </label>

                                      <Checkbox
                                        disabled={view}
                                        id={`geoposicao-${index}`}
                                        checked={!!form.manualCoordinatesEnabled}
                                        onChange={(event, isChecked) => {
                                          setFormFields((prev) => {
                                            const newFormFields = [...prev];
                                            newFormFields[indiceReal] = {
                                              ...newFormFields[indiceReal],
                                              manualCoordinatesEnabled: isChecked,
                                            };
                                            return newFormFields;
                                          });
                                        }}
                                      />
                                    </div>
                                  </div>

                                  <div className="col-md-3 mb-4">
                                    <div className="d-flex align-items-center" style={{ height: "0px" }}>
                                      <a
                                        style={{ cursor: "pointer" }}
                                        href={`https://www.google.com/maps/search/?api=1&query=${form.latitude},${form.longitude}`}
                                        target="_blank"
                                        rel="noreferrer noopener"
                                      >
                                        <label style={{ cursor: "pointer" }} className="font-test mb-0">
                                          Visualizar no Mapa
                                        </label>
                                      </a>
                                    </div>
                                  </div>
                                </div>

                                {/* Observacao + Canhoto */}
                                <div className="row">
                                  <div className="col-md-12 mb-2">
                                    <label htmlFor="observation" className="font-test">
                                      Observações
                                    </label>
                                    <TextArea
                                      disabled={view}
                                      name="observation"
                                      value={form.observation && form.observation}
                                      onChange={(event) => handleFormChange(event, indiceReal)}
                                    />
                                  </div>

                                  <div className="row justify-content-between align-items-center gx-3 ">
                                    {form.canhoto ? (
                                      <GalleryDialog data={form.canhoto} />
                                    ) : (
                                      <>
                                        {id ? (
                                          <div className="gap-2.5">
                                            <span className="font-test gap-2" style={{ color: "red" }}>
                                              Ainda não há comprovante de entrega
                                            </span>

                                            <Button
                                              disabled={view}
                                              variant="outlined"
                                              onClick={() => {
                                                setReferenc(null);
                                                handleClickOpen(form.id, form.operation[0]);
                                                setOrigem("Canhoto");
                                              }}
                                            >
                                              {nameButtonImport}
                                            </Button>
                                          </div>
                                        ) : (
                                          ""
                                        )}
                                      </>
                                    )}
                                  </div>
                                </div>
                              </Spin>
                            </div>
                          </Card>
                        </Box>
                      );
                    })}

                    <div className="row">
                      <div className="col-12 text-end">
                        <Button
                          variant="contained"
                          style={{ backgroundColor: "#012443" }}
                          onClick={addFields}
                          startIcon={<AddIcon />}
                        >
                          Adicionar Ponto de Parada
                        </Button>
                      </div>
                    </div>
                  </Card>


                  {/* Veículo */}
                  <Card
                    sx={{ padding: 2 }}
                    className="form-signin mx-auto mb-4 mb-lg-6 border border-[10px] border-[#001f3f] rounded-lg p-3"
                    style={{
                      background: "#ffffff",
                      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.15)",
                      borderRadius: "16px",
                      width: "100%",
                    }}
                  >
                    <h4 className="mb-3">
                      <LocalShippingIcon className="localShippingIcon" />{" "}
                      Veículo
                    </h4>

                    <div className="container mt-4">
                      <div className="row justify-content-center">
                        <div className="col-lg-10 col-md-12">
                          <strong>
                            <label
                              htmlFor="occupation"
                              className="form-label h5 mb-3"
                            >
                              <Chip
                                label="Tipo de Veículo"
                                sx={{
                                  backgroundColor: "#012443",
                                  color: "white",
                                  fontWeight: "bold",
                                  border: "2px solid #FF3100",
                                  width: 150,
                                  height: 30,
                                  whiteSpace: "normal",
                                  justifyContent: "center",

                                  // Estilizando elementos internos (slots)
                                  "& .MuiChip-label": {
                                    fontSize: "0.9rem",
                                    paddingLeft: "4px",
                                    textAlign: "center",
                                  },
                                }}
                              />{" "}
                              <span style={{ color: "red" }}>*</span>
                            </label>
                          </strong>

                          <div className="left-section">
                            {renderCategories()}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="container mt-4">
                      <div className="row justify-content-center">
                        <div className="col-lg-10 col-md-12">
                          <strong>
                            <label
                              htmlFor="bodywork-label"
                              className="form-label h5 mb-3"
                            >
                              <Chip
                                label="Tipo de Carroceria"
                                sx={{
                                  backgroundColor: "#012443",
                                  color: "white",
                                  fontWeight: "bold",
                                  border: "2px solid #FF3100",
                                  width: 170,
                                  height: 30,
                                  whiteSpace: "normal",
                                  justifyContent: "center",

                                  "& .MuiChip-label": {
                                    fontSize: "0.9rem",
                                    paddingLeft: "4px",
                                    textAlign: "center",
                                  },
                                }}
                              />{" "}
                              <span style={{ color: "red" }}>*</span>
                            </label>
                          </strong>

                          <div className="left-section">
                            {renderCategoriesBodyWork()}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row" style={{ marginTop: "2%" }}>
                      {/* Campo Ocupacao */}
                      <div className="col-md-6 d-flex flex-column justify-content-center">
                        <label
                          style={{ fontWeight: "bold" }}
                          htmlFor="occupation"
                          className="form-label"
                        >
                          {"Ocupa\u00e7\u00e3o"} <span style={{ color: "red" }}>*</span>
                        </label>

                        <div className="col-md-6">
                          <select
                            disabled={view}
                            className="form-select"
                            onChange={(e) => setOccupation(e.target.value)}
                            value={occupation || ""}
                          >
                            <option value="">Selecione</option>
                            <option value="Fracionado">Fracionado</option>
                            <option value="Dedicado">Dedicado</option>
                          </select>
                        </div>
                      </div>

                      {/* Campo Livre de Carga e Descarga */}
                      <div className="col-md-6 d-flex justify-content-end align-items-center">
                        <div className="free-charge-wrapper">
                          <label
                            htmlFor="freeOfCharge"
                            className="free-charge-title"
                          >
                            Livre de Carga e Descarga{" "}
                            <span style={{ color: "red" }}>*</span>
                          </label>

                          <div className="free-charge-group">
                            <input
                              disabled={view}
                              type="radio"
                              onChange={(e) =>
                                setFreeOfCharge(e.target.value)
                              }
                              checked={freeOfCharge === "SIM"}
                              value="SIM"
                              className="free-charge-radio"
                              name="freeOfCharge"
                              id="btnFreeYes"
                              autoComplete="off"
                            />
                            <label
                              htmlFor="btnFreeYes"
                              className="free-charge-btn free-charge-yes"
                            >
                              SIM
                            </label>

                            <input
                              disabled={view}
                              type="radio"
                              onChange={(e) =>
                                setFreeOfCharge(e.target.value)
                              }
                              checked={freeOfCharge === "NAO"}
                              value="NAO"
                              className="free-charge-radio"
                              name="freeOfCharge"
                              id="btnFreeNo"
                              autoComplete="off"
                            />
                            <label
                              htmlFor="btnFreeNo"
                              className="free-charge-btn free-charge-no"
                            > {"N\u00c3O"} </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Card>


                  {/* Precificacao */}
                  <Card
                    sx={{ padding: 2, paddingLeft: 0 }}
                    className="mb-3 form-signin mx-auto mb-4 mb-lg-6 border border-[10px] border-[#344d66] rounded-lg p-3"
                    style={{
                      background: "#ffffff",
                      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.15)",
                      borderRadius: "16px",
                    }}
                  >
                    <h4 className="mb-3">
                      <InventoryIcon /> {"Precifica\u00e7\u00e3o"}
                    </h4>

                    <div>
                      <ProductTable
                        product={product}
                        onChange={handleProductsChange}
                      />
                    </div>
                  </Card>


                  {/* Resumo da Negociação */}
                  <Card
                    sx={{ padding: 2 }}
                    className="mb-3 form-signin mx-auto mb-4 mb-lg-6 border border-[10px] border-[#001f3f] rounded-lg p-3"
                    style={{
                      background: "#ffffff",
                      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.15)",
                      borderRadius: "16px",
                    }}
                  >
                    <h4 className="mb-3">
                      <CheckCircleOutlineIcon /> Resumo da Negociação
                    </h4>

                    {/* LINHA 1 */}
                    <div className="row justify-content-between align-items-center gx-3">
                      <div className="col-3">
                        <label htmlFor="seller" className="font-test">
                          Vendedor <span style={{ color: "red" }}>*</span>
                        </label>

                        <Autocomplete
                          disabled={view}
                          id="seller-select"
                          size="small"
                          options={sellersList}
                          getOptionLabel={(option) =>
                            typeof option === "string" ? option : formatName(option.name)
                          }
                          value={sellersList.find((s) => s.name === seller) || seller}
                          onChange={(event, newValue) => {
                            setSeller(newValue ? newValue.name : "");
                          }}
                          onInputChange={(event, newInputValue) => {
                            setSeller(newInputValue);
                          }}
                          noOptionsText="Nenhum vendedor encontrado"
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label=""
                              placeholder="Selecione o vendedor"
                              id="seller"
                            />
                          )}
                          isOptionEqualToValue={(option, value) =>
                            option.name === value.name
                          }
                          forcePopupIcon
                          popupIcon={<KeyboardArrowDownIcon />}
                        />
                      </div>

                      <div className="col-3">
                        <label htmlFor="weightCargo" className="font-test">
                          Peso Transportado (Kg) <span style={{ color: "red" }}>*</span>
                        </label>

                        <IntlCurrencyInput
                          disabled={view}
                          currency="BRL"
                          config={weightConfig}
                          placeholder="00.00"
                          onChange={handleChangeWeightCargo}
                          value={weightCargo && weightCargo}
                          className="form-control"
                          id="weightCargo"
                          maxLength={10}
                        />
                      </div>

                      <div className="col-3">
                        <label htmlFor="valueNF" className="font-test">
                          Valor Transportado <span style={{ color: "red" }}>*</span>
                        </label>

                        <IntlCurrencyInput
                          disabled={view}
                          currency="BRL"
                          config={currencyConfig}
                          placeholder="00.00"
                          onChange={handleChangeValueNF}
                          value={valueNF && valueNF}
                          className="form-control"
                          id="valueNF"
                          maxLength={15}
                        />
                      </div>

                      <div className="col-3">
                        <label htmlFor="valueFreightage" className="font-test">
                          Valor do Frete <span style={{ color: "red" }}>*</span>
                        </label>

                        <IntlCurrencyInput
                          disabled
                          currency="BRL"
                          config={currencyConfig}
                          placeholder="00.00"
                          onChange={handleChangeValueFreightage}
                          value={valueFreightage && valueFreightage}
                          className="form-control"
                          id="valueFreightage"
                          maxLength={15}
                        />
                      </div>
                    </div>

                    {/* LINHA 2 */}
                    <div className="row justify-content-between align-items-center gx-3">
                      <div className="col-3">
                        <label htmlFor="paymentCondition" className="font-test">
                          Condições de Pagamento <span style={{ color: "red" }}>*</span>
                        </label>

                        {/* Select dinamico:
                            as opcoes sao carregadas do financeiro do embarcador (newEmbarcador),
                            não mais de uma lista fixa hardcoded. */}
                        <select
                          disabled={verifyPayment || view}
                          value={paymentCondition && paymentCondition}
                          id="paymentCondition"
                          className="form-select"
                          onChange={handleChangePaymentCondition}
                        >
                          <option value="">Selecione</option>
                          {/* Opcoes vem do financeiro do embarcador (newEmbarcador). */}
                          {(() => {
                            // Mantém o valor atual visível mesmo que não esteja mais na lista do embarcador.
                            const optionsToRender =
                              paymentCondition &&
                              !paymentConditionOptions.includes(paymentCondition)
                                ? [...paymentConditionOptions, paymentCondition]
                                : paymentConditionOptions;

                            return optionsToRender.map((option) => (
                              <option key={option} value={option}>
                                {option}
                              </option>
                            ));
                          })()}
                        </select>
                      </div>



                      <div className="col-3">
                        <label htmlFor="deliveryDeadline" className="font-test">
                          Prazo de Entrega
                        </label>

                        <input
                          type="date"
                          className="form-control"
                          id="deliveryDeadline"
                          value={deliveryDeadline || ""}
                          onChange={(e) => setDeliveryDeadline(e.target.value)}
                          disabled={view}
                        />
                      </div>
                    </div>

                    {/* OBSERVACOES */}
                    <div className="row gx-3 mt-3">
                      <div className="col-12">
                        <label htmlFor="observation" className="font-test">
                          Observações
                        </label>

                        <TextArea
                          rows={4}
                          disabled={view}
                          value={observation || ""}
                          onChange={(e) => setObservation(e.target.value)}
                          placeholder="Observações sobre o orçamento"
                        />
                      </div>
                    </div>
                  </Card>


                  {/* Botoes */}
                  <div className="row mb-4">
                    <div className="col-12 text-end">
                      <div
                        style={{
                          display: "flex",
                          gap: "10px",
                          justifyContent: "flex-end",
                          alignItems: "stretch",
                          flexWrap: "wrap",
                        }}
                      >
                        <div
                          className="btn-class-cadastrar"
                          style={{ flex: 1, maxWidth: "240px" }}
                        >
                          <Link to="/orcamento/listagem">
                            <button
                              type="button"
                              className="w-100 btn btn-cadastrar"
                              style={{ height: "44px", whiteSpace: "normal" }}
                            >
                              Voltar
                            </button>
                          </Link>
                        </div>
                        <div
                          className="btn-class-cadastrar"
                          style={{ flex: 1, maxWidth: "240px" }}
                        >
                          <button
                            type="button"
                            className="w-100 btn btn-cadastrar"
                            onClick={save}
                            disabled={carregando === 1}
                            style={{ height: "44px", whiteSpace: "normal" }}
                          >
                            Salvar
                          </button>
                        </div>
                        <div
                          className="btn-class-cadastrar"
                          style={{ flex: 1, maxWidth: "240px" }}
                        >
                          <button
                            type="button"
                            className="w-100 btn btn-cadastrar"
                            onClick={saveAndEmitPdfV2}
                            disabled={carregando === 1}
                            style={{ height: "44px", whiteSpace: "normal" }}
                          >
                            Salvar e emitir PDF
                          </button>
                        </div>
                        {id && (isBudgetOpenStatus(status) || normalizeText(status) === "enviado") && (
                          <div
                            className="btn-class-cadastrar"
                            style={{ flex: 1, maxWidth: "240px" }}
                          >
                            <button
                              type="button"
                              className="w-100 btn btn-cadastrar"
                              onClick={sendBudgetPdfByEmail}
                              disabled={carregando === 1 || view}
                              style={{ height: "44px", whiteSpace: "nowrap" }}
                            >
                              Enviar PDF por e-mail
                            </button>
                          </div>
                        )}
                        {id && (isBudgetOpenStatus(status) || normalizeText(status) === "enviado") && (
                          <div
                            className="btn-class-cadastrar"
                            style={{ flex: 1, maxWidth: "240px" }}
                          >
                            <button
                              type="button"
                              className="w-100 btn btn-cadastrar"
                              onClick={sendBudgetPdfByWhatsApp}
                              disabled={carregando === 1 || view}
                              style={{ height: "44px", whiteSpace: "normal" }}
                            >
                              Enviar WhatsApp
                            </button>
                          </div>
                        )}
                        {canApprove && id && status !== "Aprovado" && status !== "Cancelado" && (
                          <div
                            className="btn-class-cadastrar"
                            style={{ flex: 1, maxWidth: "240px" }}
                          >
                            <button
                              type="button"
                              className="w-100 btn btn-success btn-cadastrar"
                              onClick={approveBudget}
                              disabled={carregando === 1}
                              style={{ backgroundColor: "#28a745", borderColor: "#28a745", height: "44px", whiteSpace: "normal" }}
                            >
                              Aprovar Orcamento
                            </button>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                {/* Dialog de mensagem */}
                <ModernAlertDialog
                  open={open}
                  handleClose={() => setOpen(false)}
                  title={title}
                  msg={msg}
                />
              </div>
            </Box>
          }
        />
      ) : (
        <Navigate to="/login" />
      )}
    </>
  );
}

export default Budget;





















